import { useEffect } from "react";

const SITE = "https://mentheris.com";

function upsert(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function usePageTitle(title, description, path) {
  useEffect(() => {
    const url = SITE + (path || window.location.pathname);
    if (title) document.title = title;

    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    if (title) {
      upsert("property", "og:title", title);
      upsert("name", "twitter:title", title);
    }
    if (description) {
      upsert("property", "og:description", description);
      upsert("name", "twitter:description", description);
    }
    upsert("property", "og:url", url);
    upsert("property", "og:image", `${SITE}/images/og.png`);
    upsert("name", "twitter:image", `${SITE}/images/og.png`);
  }, [title, description, path]);
}
